/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")




  export type API49148Req = {};



export interface API49148Res {
  /** 是否有权限,false:没有权限,true:有权限  */
  havePermission?: boolean;
  /** 项目数量 ,ProjectNumResp  */
  projectNum?: any;
  /** 项目平均进度 ,ProjectAvgResp  */
  projectAvg?: any;
  /** 任务数量 ,TaskNumResp  */
  taskNum?: any;
  /** 项目人员 ,TeamMemberResp  */
  projectMember?: any;
  
};


// 49148 项目概览 - 是否有权限

export interface IUseGetAPI49148Return {
  /** 项目概览 - 是否有权限: 接口请求状态 */
  isAPI49148Loading: boolean;
  /** 项目概览 - 是否有权限: 接口请求返回数据 */
  dataAPI49148: API49148Res;
  /**  项目概览 - 是否有权限: 接口数据请求方法 */
  fetchAPI49148Data:  ( config?: YWRequestConfig) => Promise<API49148Res>;
  /** 项目概览 - 是否有权限: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI49148 = ():IUseGetAPI49148Return => {
  let isMount = true;
  const [isAPI49148Loading, setIsAPI49148Loading] = useState(false);
  const [dataAPI49148, setDataAPI49148] = useState<API49148Res>({} as API49148Res);
  const requestUrl = `${basePath}/corp-admin/project/bi/permission/v1`;

  const fetchAPI49148Data = async ( config?: YWRequestConfig): Promise<API49148Res> => {
  
    if ( isMount ) {
      setIsAPI49148Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API49148Res>(`${basePath}/corp-admin/project/bi/permission/v1`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI49148(res || {} as API49148Res);
        setIsAPI49148Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI49148Loading(false);
      }
      return false as unknown as API49148Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI49148Loading,
    dataAPI49148,
    fetchAPI49148Data,
    requestUrl,
  }
}

